import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'suffixCammasForTChart',
})
export class SuffixCammasPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(input: any, args: number = 0, ep?: number, showDollar: boolean = true): any {
    const suffixes = ['K', 'M', 'B', 'T', 'P', 'E'];

    if (Number.isNaN(input) || !this.isNumeric(input)) {
      return input;
    }

    const prefix = showDollar ? '$' : '';


    if (Math.abs(input) < 10 && Math.abs(input) > 0) {
      return prefix + Number(input).toFixed(args);
    } else {
      if (ep === 0) {
        return prefix + this.currencyPipe.transform(input, ' ', '', '1.0-0');
      }

      const exp = ep ?? Math.floor(Math.log10(Math.abs(input)) / 3);
      const formattedValue = (input / Math.pow(1000, exp)).toFixed(args);

      // If exp is 0, no suffix
      if (exp === 0) {
        return prefix + this.addCommas(formattedValue);
      }

      return prefix + this.addCommas(formattedValue) + suffixes[exp - 1];
    }
  }

  isNumeric(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  addCommas(value: string): string {
    const [integerPart, decimalPart] = value.split('.');
    return (
      integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      (decimalPart ? '.' + decimalPart : '')
    );
  }
}
